<script lang="ts" setup>
import AddToCartBtn from '~/features/search/AddToCartBtn.vue'
import ProductsTableHeader from '~/entities/search/tables/ProductsTableHeader.vue'
import ProductTableRow from '~/entities/search/tables/ProductTableRow.vue'
import WatchMoreAccordion from '~/components/ui/accordion/WatchMoreAccordion.vue'
import type { ISearchProduct } from '~/shared/interfaces/search/products'
import getFormatTitle from '~/composables/product-title-formatter'

const props = defineProps<{
  products: ISearchProduct[]
  tableTitle?: string
  showWarehousesCount: number
  isOriginalProduct: boolean
  hasTableHeader?: boolean
}>()

const hasWarehouses = computed(
  () => !(props.isOriginalProduct && !props.products[0].warehouses.length)
)

</script>

<template>
  <div
    class="search__table-block"
    :class="!products.length && 'search__table-block_empty'"
  >
    <h2 class="search__table-title" v-if="tableTitle">
      {{ tableTitle }}
    </h2>
    <template v-if="products.length && hasWarehouses">
      <ProductsTableHeader v-if="hasTableHeader" />
      <div class="search__table-container">
        <div
          v-for="(product, productIndex) in products"
          class="search__table-item"
        >
          <div class="search__table-product">
            <div class="search__table-product-brand-and-article">
              <div class="search__table-product-brand">{{ product.brand.name }}</div>
              <NuxtLink class="search__table-product-article" :to="product.searchLink">
                {{ product.article }}
              </NuxtLink>
            </div>
            <NuxtLink
              class="search__table-product-title"
              :class="!product.warehouses.filter((_, index) => index === 0)[0].productLink?.length && 'not-link'"
              :to="product.warehouses.filter((_, index) => index === 0)[0].productLink"
            >
              {{ getFormatTitle(product.title) }}
            </NuxtLink>
          </div>
          <WatchMoreAccordion
            :watch-more-btn-text="{
              open: `Ещё предложения`,
            }"
            :watch-more-is-visible="
              product.warehouses.length > showWarehousesCount
            "
          >
            <template #initialContent>
              <ProductTableRow
                v-for="(warehouse, index) in product.warehouses.slice(
                  0,
                  showWarehousesCount
                )"
                :key="`${warehouse.id}_${index}_initial`"
                :class="
                  product.warehouses.slice(0, showWarehousesCount).length ===
                    1 && 'search__table-row_once'
                "
                :product="product"
                :warehouse="warehouse"
                :is-original-product="isOriginalProduct"
                :show-base-product-info="index == 0"
                :product-position="productIndex"
                :warehouse-position="index"
              />
            </template>
            <template #hiddenContent>
              <ProductTableRow
                v-for="(warehouse, index) in product.warehouses.slice(
                  showWarehousesCount,
                  product.warehouses.length
                )"
                :key="`${warehouse.id}_${index}_hidden`"
                :product="product"
                :warehouse="warehouse"
                :is-original-product="isOriginalProduct"
                :product-position="productIndex"
                :warehouse-position="index + showWarehousesCount"
              />
            </template>
          </WatchMoreAccordion>
        </div>
      </div>
    </template>
    <p v-else class="search__table-empty-txt">Предложения отсутствуют</p>
  </div>
</template>


<style lang="scss" scoped>
@include md-breakpoint {
  :deep(.watch-more) {
    margin-top: 16px;
  }
}
</style>
